// extracted by mini-css-extract-plugin
module.exports = {"dialogTitle":"AuthDialog_dialogTitle__2CVt1","inputs":"AuthDialog_inputs__2l_DR","errorMessage":"AuthDialog_errorMessage__2XBMM","dialogActions":"AuthDialog_dialogActions__3X-O8"};